import React from "react";
import styled from "styled-components";
import { FormattedMessage } from 'react-intl';

const TocSection = styled.span`
  a {
    color: ${(props) => props.theme.palette.themePrimary};
  }
`;

export const TermsLabel = ({ app, user, t }) => {

  const getLinks = () => {
    const { agent_terms_url = 'agb', agent_privacy_url = 'datenschutzerklaerung', agent_avv_url = 'avv' } = app.data || {};
    return {
      terms: agent_terms_url,
      privacy: agent_privacy_url,
      avv: agent_avv_url
    };
  }

  const getUrl = (page) => {
    if (page.startsWith('http'))
      return `${page}?locale=${user.claims.locale}`;

    // HACK-ing
    if (app.config.tenant.startsWith('propnow'))
      return `${window.location.origin.replace('://app.', `://${user.claims.tenant}.`)}/content/${page}?locale=${user.claims.locale}`;

    return `/content/${page}?locale=${user.claims.locale}`;
  }

  const handleOpenToc = (e, page) => {
    e.preventDefault();
    e.stopPropagation();

    window.open(getUrl(page));
  };

  const links = getLinks();

  if (app.tenant === "remax-at") {
    return <TocSection theme={app.theme}>
      Ich stimme den{' '}
      <a onClick={(e) => handleOpenToc(e, links.terms)}>AGBs</a> und den{' '}
      <a onClick={(e) => handleOpenToc(e, 'https://res.cloudinary.com/auctiontech/image/upload/v1688394942/dav/data/Richtlinie-digitales-Angebotsverfahren_2022.pdf')}>Verhaltensrichtlinien</a> zu.
    </TocSection>
  }

  return (

    <TocSection theme={app.theme}>
      <FormattedMessage
        id="SaleCreatePanel::i_agree_to_the_link"
        values={{
          agbs: (
            <a onClick={(e) => handleOpenToc(e, links.terms)}>
              {t('agbs')}
            </a>
          ),
          dataprotection: (
            <a onClick={(e) => handleOpenToc(e, links.privacy)}>
              {t('dataprotection')}
            </a>
          ),
          avv: (
            <a onClick={(e) => handleOpenToc(e, links.avv)}>
              {t('avv')}
            </a>
          ),
        }}
      />
    </TocSection>
  )
}



// WEBPACK FOOTER //
// ./src/app/components/TermsLabel/index.jsx